class ImageLinker {
  constructor(options = {}) {
    this.config = {
      buttonPrimaryLinks: document.querySelectorAll('.js-fill-buttonprimary-link'),
      buttonLinks: document.querySelectorAll('.js-fill-button-link'),
      ...options
    };
  }

  static setAnchorElement(_module, _btn, className) {
    const module = _module;
    const btn = _btn;
    const macro = module.querySelector('.o-macro');

    if (!btn || !btn.target || !macro) return;

    const link = btn.getAttribute('href');
    btn.style.display = 'none';

    if (!link) return;

    const buttonElement = macro.querySelector('.o-flexcolumns');
    macro.removeChild(buttonElement);
    const linkingParent = document.createElement('a');
    linkingParent.className = className;
    linkingParent.setAttribute('href', link);
    linkingParent.appendChild(macro);
    module.innerHTML = '';
    module.appendChild(linkingParent);
    linkingParent.target = btn.target;
  }

  init() {
    const { buttonPrimaryLinks, buttonLinks } = this.config;

    if (buttonPrimaryLinks !== undefined) {
      buttonPrimaryLinks.forEach(_module => {
        const module = _module;
        const className = 'c-link-from-btnprimary';
        const btn = module.querySelector('.btn-primary');
        ImageLinker.setAnchorElement(module, btn, className);
      });
    }

    if (buttonLinks) {
      buttonLinks.forEach(_module => {
        const module = _module;
        const className = 'c-link-from-btnlink';
        const btn = module.querySelector('.btn-link');
        ImageLinker.setAnchorElement(module, btn, className);
      });
    }
  }
}

export default ImageLinker;
